import React from "react";
import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.custom.color.white,
  },
}));

const SuspenceLoader = (props) => {
  const classes = useStyles();

  return (
    <Backdrop
      className={[classes.backdrop, props.className].join(" ")}
      open={true}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

SuspenceLoader.propTypes = {
  className: PropTypes.string,
};

export { SuspenceLoader };
